/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { absencesReducer } from '@absences/store/absences.reducer';
import { AbsencesState } from '@absences/store/absences.state';
import { AppointmentState } from '@app/appointments/store/appointment.state';
import { customersReducer } from '@app/customers/store/customers.reducer';
import { CustomersState } from '@app/customers/store/customers.state';
import { usersReducer } from '@app/user/store/users.reducer';
import { UsersState } from '@app/user/store/users.state';
import { appointmentReducer } from '@appointments/store/appointment.reducer';
import { authReducer } from '@auth/store/auth.reducer';
import { AuthState } from '@auth/store/auth.state';
import { constructionSitesReducer } from '@construction-sites/store/construction-sites.reducer';
import { ConstructionSitesState } from '@construction-sites/store/construction-sites.state';
import { departmentsReducer } from '@departments/store/departments.reducer';
import { DepartmentsState } from '@departments/store/departments.state';
import { driversReducer } from '@drivers/store/drivers.reducer';
import { DriversState } from '@drivers/store/drivers.state';
import { ActionReducerMap } from '@ngrx/store';
import { remindersReducer } from '@reminders/store/reminders.reducer';
import { RemindersState } from '@reminders/store/reminders.state';
import { toursReducer } from '@tours/store/tours.reducer';
import { ToursState } from '@tours/store/tours.state';
import { vehiclesReducer } from '@vehicles/store/vehicles.reducer';
import { VehiclesState } from '@vehicles/store/vehicles.state';

export interface State {
  auth: AuthState;
  tours: ToursState;
  vehicles: VehiclesState;
  customers: CustomersState;
  drivers: DriversState;
  departments: DepartmentsState;
  absences: AbsencesState;
  users: UsersState;
  constructionSites: ConstructionSitesState;
  appointments: AppointmentState;
  reminders: RemindersState;
}

export const reducers: ActionReducerMap<State> = {
  auth: authReducer,
  tours: toursReducer,
  vehicles: vehiclesReducer,
  customers: customersReducer,
  drivers: driversReducer,
  departments: departmentsReducer,
  absences: absencesReducer,
  users: usersReducer,
  constructionSites: constructionSitesReducer,
  appointments: appointmentReducer,
  reminders: remindersReducer
};
